var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefsixRoundIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    display: "inline"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.249988,
    cy: 250.000003,
    fill: "black",
    id: "svg_1",
    rx: 237.499988,
    ry: 237.499988,
    stroke: "#d3e03c",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#fff;stroke-miterlimit:10;stroke-width:16px;}.cls-4{fill:#d5e830;}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "black",
    height: 911,
    id: "svg_20",
    transform: "rotate(-75.67 -893.3 -1242.91)",
    width: 271,
    x: -1028.800001,
    y: -1698.409998
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    display: "inline"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 2"), /*#__PURE__*/React.createElement("g", {
    className: "cls-2",
    id: "svg_13",
    transform: "matrix(1.57057 0 0 1.57057 66.297 120.01)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m168.891727,140.646081a61.38,61.38 0 0 1 -74.65,44.28a61.38,61.38 0 0 1 -44.28,-74.65a61.15,61.15 0 0 1 11.52,-23.23a61.39,61.39 0 0 1 63.1,-21.08a61.38,61.38 0 0 1 44.31,74.68z",
    id: "svg_18"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -177.868256,
    cy: -872.82392,
    id: "svg_17",
    r: 37.75,
    transform: "rotate(-75.67 608.312 -558.574)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.101727,116.496081l43.76,-171.37l98,25l-43.76,171.37l-98,-25zm111.67,-46.15c-12.56,-9 -16.44,-22 -16.13,-36.18a167.55,167.55 0 0 1 3.66,-31.08c2.31,-10.86 6.23,-21.37 9.54,-32.33l-24.41,-13.68l-72.73,130.07c5.58,2.27 8.9,1.26 12.53,-2.77c19.87,-22.09 52.57,-26.88 77.52,-11.48c4.44,2.75 7.07,1.64 10.02,-2.55z",
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m151.771727,70.346081c-2.94,4.19 -5.58,5.29 -10,2.55c-24.95,-15.4 -57.64,-10.61 -77.52,11.48a26.29,26.29 0 0 1 -5.47,3.74a33.74,33.74 0 0 1 -10,3.51l75.65,-134.55l24.41,13.68c-3.3,11 -7.22,21.47 -9.54,32.33a167.55,167.55 0 0 0 -3.66,31.08c-0.31,14.22 3.56,27.2 16.13,36.18z",
    id: "svg_15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefsixRoundIcon);
export default __webpack_public_path__ + "static/media/refsix-round-icon.14aafd2b1f4225d2e14ea85ece99f101.svg";
export { ForwardRef as ReactComponent };